import React from 'react';

import {Box, Skeleton} from '@mui/material';

const CardThemesCarouselSkeleton: React.FC = ({}) => {
  return (
    <Box
      sx={{
        width: '520px',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        gap: '32px',
      }}>
      <Box
        sx={{
          width: '100%',
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'center',
          alignSelf: 'stretch',
          gap: '12px',
        }}>
        <Skeleton
          variant="rounded"
          width={'84px'}
          height={'24px'}
          sx={{borderRadius: 2}}
          animation="wave"
        />
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: '8px',
          }}>
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'28px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'center',
          alignSelf: 'stretch',
          gap: '12px',
        }}>
        <Skeleton
          variant="rounded"
          width={'84px'}
          height={'24px'}
          sx={{borderRadius: 2}}
          animation="wave"
        />
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: '8px',
          }}>
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'28px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'center',
          alignSelf: 'stretch',
          gap: '12px',
        }}>
        <Skeleton
          variant="rounded"
          width={'84px'}
          height={'24px'}
          sx={{borderRadius: 2}}
          animation="wave"
        />
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: '8px',
          }}>
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'28px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'center',
          alignSelf: 'stretch',
          gap: '12px',
        }}>
        <Skeleton
          variant="rounded"
          width={'84px'}
          height={'24px'}
          sx={{borderRadius: 2}}
          animation="wave"
        />
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: '8px',
          }}>
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'151px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
          <Skeleton
            variant="rectangular"
            width={'28px'}
            height={'95px'}
            sx={{borderRadius: '5.2px'}}
            animation="pulse"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CardThemesCarouselSkeleton;
